import { Button } from '@mantine/core'
import './UserSubscriptionCard.css'
import moment from 'moment'

export default function UserSubscriptionCard({ subscription }) {

   const IS_INACTIVE = !subscription || !subscription?.is_active

   return (
      <>
         <div className='UserSubscriptionCard-main-container'>
            <h4 className='UserSubscriptionCard--titleCard'>
               {IS_INACTIVE ? "¿Todavía no te has suscripto?" : "Tu suscripción está activa"}
            </h4>
            {!IS_INACTIVE
               ? <div className='UserSubscriptionCard-column-container'>
                  <span>Desde: {moment(subscription.startDate).format("D [de] MMMM [de] YYYY")}</span>
                  <span>Válida hasta: {moment(subscription.endDate).format("D [de] MMMM [de] YYYY")}</span>
               </div>
               : <div className='UserSubscriptionCard-column-container'>
                  <p>
                     ¡No te pierdas de nada! <br /> Accedé a todo el contenido sin límites
                  </p>
                  <Button
                     component='a'
                     href='https://forvet.org/suscripciones'
                     // href={`${process.env.REACT_APP_FRONTEND_SERVER}/suscripciones`}
                     target='_blank'
                     variant='light'
                     color='#FF7BAC'
                  >
                     Ver planes
                  </Button>
               </div>
            }
         </div>
      </>

   )
}
